import React from "react";
import NewMetahutContainer from "../metahuts/NewMetahutContainer";

const NewMetahut = () => {
    return (
            <NewMetahutContainer />
    )
}

export default NewMetahut;